import { render, staticRenderFns } from "./IntegrationList.vue?vue&type=template&id=e58df088&scoped=true&"
import script from "./IntegrationList.vue?vue&type=script&lang=js&"
export * from "./IntegrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58df088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e58df088')) {
      api.createRecord('e58df088', component.options)
    } else {
      api.reload('e58df088', component.options)
    }
    module.hot.accept("./IntegrationList.vue?vue&type=template&id=e58df088&scoped=true&", function () {
      api.rerender('e58df088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Integrations/IntegrationList.vue"
export default component.exports